import { GoogleLogin } from "@react-oauth/google";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const SocialButtons = () => {
    const navigate = useNavigate();

     const responseMessage = (response: any) => {
        //console.log(response);
        const details= jwtDecode(response.credential);
        localStorage.setItem('googleProfile', JSON.stringify(details));
        localStorage.setItem('auth-user', JSON.stringify(details));
        navigate('/catalog');
    };

    const errorMessage = () => {
        console.log('Error');
    };

    return (
        <Row className="mb-3 login-btns" style={{ marginLeft: "0" }}>
            <Form.Group as={Col} xs="4" controlId="validationCustom10">
                <div className='align-center btn-out margin-0'>
                    <Button onClick={() => navigate('/register')} variant="light">Facebook</Button>
                </div>
            </Form.Group>
            <Form.Group as={Col} xs="4"  controlId="validationCustom11">
                <div className='align-center btn-out margin-0'>
                    <Button onClick={() => navigate('/register')} variant="light">Linked in</Button>
                </div>
            </Form.Group>
            <Form.Group as={Col} xs="4" controlId="validationCustom12">
                <div className='align-center btn-out margin-0 google-login'>
                    {/* <Button onClick={() => handleLoginUser('Google')} variant="light">Google</Button> */}
                    <GoogleLogin onSuccess={responseMessage}  onError={errorMessage} type='standard'/>
                </div>
            </Form.Group>
        </Row>
    )
}

export default SocialButtons;